<template>

  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button variant="success" :to="{ name: 'collection-create' }">
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
      </template>
    </app-breadcrumb>

    <!-- <state-form @reloadPage="handleReloadPage" @dataForm="fetchShow" /> -->
    <!-- Table Container Card -->
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <b-card no-body class="mb-0">
        <b-table ref="refRoleListTable" class="position-relative" :items="itemsData" responsive :fields="tableColumns"
          primary-key="id" :sort-by.sync="sortBy" show-empty empty-text="Không tìm thấy kết quả"
          :sort-desc.sync="isSortDirDesc">
          <template #cell(status)="data">

            <b-form-checkbox :checked="data.item.status == 1 ? true : false" class="custom-control-success"
              name="check-button" switch @input="updateStatus(data.item)"
              v-if="$can('collection.status', 'Collection')" />
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button size="sm" class="" variant="warning"
              :to="{ name: 'collection-edit', params: { id: data.item.id } }"
              v-if="$can('collection.update', 'Collection')">
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button>
            <b-button size="sm" class="ms-2" variant="danger" v-if="$can('collection.destroy', 'Collection')"
              @click="onDestroy(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{ $t('show_to_entries', {
                  from: dataMeta.from, to: dataMeta.to, of: dataMeta.of
                })
              }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

              <b-pagination v-model="currentPage" :total-rows="totalEntries" :per-page="perPage" first-number
                last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import { showToast } from '@core/utils/utils';
import {
  BOverlay, BCard, BRow, BCol, BTable, BBadge, BPagination, BButton, BFormCheckbox, VBTooltip
} from 'bootstrap-vue'
import store from '@/store';
// import StateForm from './StateForm.vue'
export default {
  data() {
    return {
      textSubmit: 'Lưu'
    }
  },
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BPagination,
    AppBreadcrumb,
    BButton,
    BFormCheckbox,
    VBTooltip
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  setup() {
    const refRoleListTable = ref(null);
    const errorMessage = ref({
      name: '',
      state: ''
    })

    const tableColumns = [
      { key: 'id', sortable: false, thAttr: { width: 40 } },
      {
        key: 'name',
        sortable: false,
        label: 'Tên trạng thái',
        thAttr: { width: '25%' },
      },
      {
        key: 'desc',
        sortable: false,
        label: 'Mô tả',
      },
      {
        key: 'status',
        sortable: false,
        label: 'Trạng thái',
        thAttr: { width: '9%' },
        tdClass: 'text-center',
      },
      {
        key: 'actions',
        label: 'Hành động',
        thAttr: { width: '15%' },
        thClass: 'action',
        tdClass: 'action',
      },
    ];

    const loading = ref(false);
    const perPage = ref(10);
    const totalEntries = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('id');
    const isSortDirDesc = ref(true);
    const isPaginate = ref(1);
    const itemsData = ref([]);

    const dataMeta = computed(() => {
      const localItemsCount = refRoleListTable.value ? refRoleListTable.value.localItems.length : 0;
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalEntries.value,
      };
    });

    const fetchAll = () => {
      loading.value = true;
      store
        .dispatch('collection/fetchAll', {
          keyword: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
          isPaginate: isPaginate.value,
        })
        .then((response) => {
          loading.value = false;
          if (response.status === 200) {

            const items = response.data.data.data;
            totalEntries.value = response.data.data.total;
            itemsData.value = items;
          }
        });
    };


    const refetchData = () => {
      fetchAll();
    };

    const handleReloadPage = () => {
      fetchAll();
    }

    watch([currentPage, perPage, searchQuery], () => {
      refetchData();
    });

    const statusOptions = [
      { label: 'Đợi duyệt', id: 2 },
      { label: 'Đã kích hoạt', id: 1 },
      { label: 'Chưa kích hoạt', id: 0 },
    ];
    const resolveRoleStatusVariant = (status) => {
      if (status === 2) return 'warning';
      if (status === 1) return 'success';
      if (status === 0) return 'secondary';
      return 'primary';
    };
    fetchAll();
    return {
      loading,
      tableColumns,
      handleReloadPage,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRoleListTable,
      itemsData,
      resolveRoleStatusVariant,
      refetchData,
      errorMessage
    }
  },
  methods: {
    updateStatus(item) {
      const { id } = item
      store.dispatch('collection/status', { id })
        .then(response => {
          const result = response.data
          showToast(result.message, { variant: (result.code) ? 'success' : '' })
        })
        .catch(error => {

        })
    },
    onDestroy(item) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn xóa nhóm đối tượng này không?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          const { id } = item
          store.dispatch('collection/destroy', { id })
            .then(response => {
              const result = response.data
              let msg_class = '';
              if (result.code === 200) {
                msg_class = 'success';
                this.refetchData()
              }
              showToast(result.message, { variant: msg_class })
            }).catch(error => {

            })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
